import React from 'react';
import { History } from 'history';
import { InputEmail } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserAuthForgotPassword extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onSave = (data: any) => {
    }

    private onChange(fieldName: string, value?: string) { 
        var email = this.state.datarow.email;
        if (fieldName === 'useremail' && value) email = Model.getEmailApp(value);

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, email: email,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(){
        this.setState({datarow: Model.defaultValueForgotPassword as any})
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} caption='Reset Your Password' buttonCaption='Send Email'
                endPoint={Model.endPointAuth+ '/forgot-password'} model={Model} datarow={this.state.datarow} validations={Model.validationForgotPassword} onError={this.onError} buttonOnBottom onSave={this.onSave}>              
                
                <InputEmail name='useremail' label='Enter Registered Email to Send Verification Code' value={this.state.datarow.useremail} error={this.state.errors?.useremail} box onChange={this.onChange} />
            </BaseCreate>
        );
    }     
     
}